import { Input } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[dropdown]',
})
export class DropdownDirective {
  @Input() reactive: boolean = false;
  @HostBinding('class.show') show = false;
  @HostBinding('class.selected') selected = false;
  @HostListener('document:click', ['$event']) toggleOpen(event) {
    if (this.elRef.nativeElement.contains(event.target)) {
      if (this.reactive && event.target.parentElement.className == 'dropmenu') {
        if (event.target.innerText == 'Clear') {
          this.elRef.nativeElement.children[0].innerText = event.target.id;
          this.selected = false;
        } else {
          this.elRef.nativeElement.children[0].innerText =
            event.target.innerText;
          this.selected = true;
        }
      }
      this.show = !this.show;
    } else {
      this.show = false;
    }
  }
  constructor(private elRef: ElementRef) {}
}
